module.exports = __webpack_public_path__ + "img/delete-gray.f2215d5d.svg";